import PropTypes from 'prop-types';
import ChecklistItem from './ChecklistItem';
import {itemShape} from '../shapes';
import {formatDateHeader} from '../utils/date';

export default function TimelineView({items, onToggleItem, onDeleteItem, onUpdateItem, onStarItem, onSetDueDateItem}) {
    if (items.length === 0) {
        return (
            <div className="empty-state">
                <p className="empty-state-text">
                    Nothing scheduled. Your calendar is as empty as your ambitions.
                </p>
            </div>
        );
    }

    const groups = [];
    let currentGroup = null;
    for (const item of items) {
        if (!currentGroup || currentGroup.date !== item.dueDate) {
            currentGroup = {date: item.dueDate, items: []};
            groups.push(currentGroup);
        }
        currentGroup.items.push(item);
    }

    return (
        <div className="timeline-view">
            {groups.map((group) => (
                <div key={group.date} className="timeline-date-group">
                    <div className="timeline-date-header">{formatDateHeader(group.date)}</div>
                    {group.items.map((item) => (
                        <div key={`${item.checklistId}-${item.id}`} className="timeline-item-wrapper">
                            <span className="timeline-checklist-label">{item.checklistTitle}</span>
                            <ChecklistItem
                                checklistId={item.checklistId}
                                item={item}
                                onToggle={onToggleItem}
                                onDelete={onDeleteItem}
                                onUpdate={onUpdateItem}
                                onStar={onStarItem}
                                onSetDueDate={onSetDueDateItem}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

const timelineItemShape = PropTypes.shape({
    ...itemShape.innerType,
    checklistId: PropTypes.string.isRequired,
    checklistTitle: PropTypes.string.isRequired,
});

TimelineView.propTypes = {
    items: PropTypes.arrayOf(timelineItemShape).isRequired,
    onToggleItem: PropTypes.func.isRequired,
    onDeleteItem: PropTypes.func.isRequired,
    onUpdateItem: PropTypes.func.isRequired,
    onStarItem: PropTypes.func.isRequired,
    onSetDueDateItem: PropTypes.func.isRequired,
};
